var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1164.1,470.6c-36.7-41.7-93.5-50.6-139-53.1c-43-2.5-102.4-1.3-177,5.1c17.7-75.8,46.8-195.9,58.1-255.3 c12.6-65.7-25.3-123.9-89.7-142.8c-61.9-17.7-122.6,8.8-144.1,61.9l-7.6,17.7C630.7,192.6,538.4,426.4,388,469.4h-1.3 c-25.3-27.8-60.7-44.2-101.1-44.2H136.5C60.7,425.2,0,485.8,0,561.7l0,456.3c0,75.8,60.7,136.5,136.5,136.5h150.4 c40.4,0,77.1-17.7,102.4-45.5c74.6,15.2,365.3,72,548.5,72c67,0,206,0,222.4-151.7c7.6-63.2,30.3-276.8,37.9-396.9 C1204.5,554.1,1194.4,504.8,1164.1,470.6L1164.1,470.6z M286.9,1076.1H136.5c-32.9,0-59.4-26.5-59.4-59.4V560.4 c0-32.9,26.5-59.4,59.4-59.4l150.4,0c32.9,0,59.4,26.5,59.4,59.4v456.3C346.3,1049.5,319.8,1076.1,286.9,1076.1L286.9,1076.1z  M1122.4,624.8c-8.8,120.1-31.6,332.4-37.9,394.3c-6.3,56.9-29.1,82.2-146.6,82.2c-161.8,0-422.2-48-515.7-67 c1.3-6.3,1.3-12.6,1.3-19v-455c0-7.6-1.3-15.2-2.5-21.5c179.5-60.7,274.3-302.1,314.7-407l6.3-16.4c8.8-22.7,36.7-21.5,50.6-16.4 c10.1,2.5,43,15.2,35.4,54.3C814,229.2,771,404.9,758.4,458c-2.5,12.6,0,25.3,8.8,34.1c7.6,8.8,20.2,13.9,32.9,12.6 c72-7.6,131.4-11.4,177-11.4c15.2,0,29.1,0,40.4,1.3c45.5,2.5,72,11.4,85.9,26.5C1121.1,538.9,1126.2,573,1122.4,624.8L1122.4,624.8 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d10861841126bb925a231c0d3e153ad6.svg";
export { ForwardRef as ReactComponent };